import request from '@/lib/api'

const _BASE = "/api";

//权限管理------------------------
//获取角色列表
export function getRoleList(data) {
  return request({
    url: `${_BASE}/iam/role/list`,
    method: 'get',
    params:data
  })
}
//获取角色列表kv
export function getKvRole() {
  return request({
    url: `${_BASE}/iam/role/kvList`,
    method: 'get',
  })
}
//获取角色对应的菜单权限树
export function getRowRoleList(id) {
  return request({
    url: `${_BASE}/iam/role/permissionTree/${id}`,
    method: 'get',
  })
}
//获取全部权限
export function getAllRole() {
  return request({
    url: `${_BASE}/iam/frontendPermission/list`,
    method: 'get',
  })
}
//添加/修改角色
export function actionRole(data) {
  return request({
    url: `${_BASE}/iam/role/`,
    method: 'post',
    data
  })
}
//修改角色信息
export function editRoleInfo(data) {
  return request({
    url: `${_BASE}/iam/role/${data.id}`,
    method: 'put',
    data
  })
}
//获取角色详情
export function getRoleInfo(id) {
  return request({
    url: `${_BASE}/iam/role/${id}`,
    method: 'get',
  })
}
//删除角色
export function deleteRole(id) {
  return request({
    url: `${_BASE}/iam/role/${id}`,
    method: 'delete'
  })
}


//用户管理----------
//用户列表
export function getUserList(data) {
  return request({
    url: `${_BASE}/iam/user/list`,
    method: 'get',
    params: data
  })
}
//添加/更新用户
export function userAction(data) {
  return request({
    url: `${_BASE}/iam/user/`,
    method: 'post',
    data
   
  })
}
//修改用户信息
export function editUserInfo(data) {
  return request({
    url: `${_BASE}/iam/user/${data.id}`,
    method: 'put',
    data
  })
}

//获取用户详情
export function getUserInfoList(id) {
  return request({
    url: `${_BASE}/iam/user/${id}`,
    method: 'get',
  })
}
//删除用户
export function deleteUser(id) {
  return request({
    url: `${_BASE}/iam/user/${id}`,
    method: 'delete'
  })
}
//用户管理1.1----------------------------------
export function getUserListV1(data) {
  return request({
    url: `${_BASE}/pmc/user/list`,
    method: 'get',
    params: data
  })
}
//添加用户
export function addUserV1(data) {
  return request({
    url: `${_BASE}/pmc/user/`,
    method: 'post',
    data
   
  })
}
//修改用户信息
export function editUserV1(data) {
  return request({
    url: `${_BASE}/pmc/user/${data.id}`,
    method: 'put',
    data
  })
}

//获取用户详情
export function getChildUserInfoV1(id) {
  return request({
    url: `${_BASE}/pmc/user/${id}`,
    method: 'get',
  })
}
//删除用户
export function deleteUserV1(id) {
  return request({
    url: `${_BASE}/pmc/user/${id}`,
    method: 'delete'
  })
}
//根据手机号获取用户名
export function getUcName(data) {
  return request({
    url: `${_BASE}/public/getUcName`,
    method: 'get',
    params: data
  })
}
//系统参数-----------------------------------------------
export function getParamList(data) {
  return request({
    url: `${_BASE}/tPmcSystemParam/list`,
    method: 'get',
    params: data
  })
}
//根据id获取子级
export function getItems(id) {
  return request({
    url: `${_BASE}/tPmcSystemParam/items/${id}`,
    method: 'get',
  })
}
//更新字典子级
export function putItem(id,data) {
  return request({
    url: `${_BASE}/tPmcSystemParam/items/${id}`,
    method: 'post',
    data
  })
}

//字典编辑==数据回显
export function getEditData(id) {
  return request({
    url: `${_BASE}/tPmcSystemParam/${id}`,
    method: 'get',
  })
}
//校验是否可以删除字典项
export function verifyDelete(data) {
  return request({
    url: `${_BASE}/tPmcSystemParam/verify_delete`,
    method: 'get',
    params: data
  })
}
// 获取邀请链接
export function getInviteUrl(id) {
  return request({
    url: `${_BASE}/pmc/user/getInviteUrl/${id}`,
    method: 'get'
  })
}